var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSaveWhite = function SvgSaveWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.25 4.75a.75.75 0 0 1 1.5 0v10.208l4.686-4.686a.75.75 0 1 1 1.06 1.06L12.53 17.3a.75.75 0 0 1-1.06 0l-5.967-5.966a.75.75 0 0 1 1.06-1.06l4.687 4.685zM5 19.48a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgSaveWhite;